import { render, staticRenderFns } from "./MetricDimension.vue?vue&type=template&id=90c1e936&scoped=true"
import script from "./MetricDimension.vue?vue&type=script&lang=ts"
export * from "./MetricDimension.vue?vue&type=script&lang=ts"
import style0 from "./MetricDimension.vue?vue&type=style&index=0&id=90c1e936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c1e936",
  null
  
)

export default component.exports